import {Inject, Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {IFeatureFlag} from "../models/featureFlag";
import {catchError} from "rxjs/internal/operators/catchError";
import {throwError} from "rxjs/internal/observable/throwError";

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagDataService {
    myAppUrl = '';
    _data: any;

    constructor(public _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.myAppUrl = baseUrl;
    }

    getFeatureFlags() {
        return this._http
            .get<IFeatureFlag[]>(this.myAppUrl + 'api/FeatureFlag/GetAllFeatureFlags')
            .pipe(catchError(this.handleError));
    }

    private handleError(error: Response) {
        return throwError(error.statusText);
    }
}